<template>
    <button
        type="submit"
        class="btn btn-primary btn-orange font-poppins font-weight-bold color-white border-radius-19"
        :disabled="disabled">
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
